import { render, staticRenderFns } from "./NewsTemplate.vue?vue&type=template&id=238ad74b&scoped=true&"
import script from "./NewsTemplate.vue?vue&type=script&lang=js&"
export * from "./NewsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewsTemplate.vue?vue&type=style&index=0&id=238ad74b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ad74b",
  null
  
)

export default component.exports